import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/SecurityConfiguration";

export const getWarrantyCoverageList = async () => {
  return axios.get(`${api_base_url}/GetWarrantyCoverage`).then((res) => {
    return res;
  });
};

export const addWarrantyCoverage = async (newWarrantyCoverage) => {
  const { data } = await axios.post(`${api_base_url}/AddWarrantyCoverage`, {
    ...newWarrantyCoverage,
  });
  return data;
};

export const deleteWarrantyCoverage = async (ids) => {
  const { data } = await axios.delete(
    `${api_base_url}/DeactivateWarrantyCoverage`,
    {
      data: ids,
    }
  );
  return data;
};

export const updateWarrantyCoverage = async (editWarrantyCoverage) => {
  const { data } = await axios.put(
    `${api_base_url}/EditWarrantyCoverage`,
    editWarrantyCoverage
  );
  return data;
};
